
































































































































































import { defineComponent, PropType, computed, ref, Ref } from '@vue/composition-api'

// components
import { Input, Select } from '@/components/general'
import { InputTime, SwitchToggle, TextArea } from '@/components/form'

// models
import { PieceworkItemsInput } from '@/models/piecework'
import { IEmployee } from '@/models/config'
import { PropOptionSelect } from '@/models'

// utils
import { getTotalHoursPiecework, getTotalWorking } from '@/utils/piecework'
import { dateLibs } from '@/utils'

// constants
import { AMOUNT_LUNCH_TYPES, ATTEND, ABSENT, CONDITIONS } from '@/constants'

// services
import { RatesLunchService } from '@/services/config'

// hooks
import { useReasonForPermission } from '@/hooks'

export default defineComponent({
  name: 'TaskSheetTable',
  components: { Input, InputTime, SwitchToggle, Select, TextArea },
  props: {
    items: {
      type: Array as PropType<PieceworkItemsInput[]>,
      required: true
    },
    employees: {
      type: Array as PropType<IEmployee[]>,
      required: true
    },
    totalWorkDescriptions: {
      type: Number,
      required: true
    },
    salaryCap: {
      type: Number as PropType<number>,
      required: true
    },
    date: {
      type: String
    },
    isHoliday: {
      type: Boolean as PropType<boolean>,
      required: true
    }
  },
  setup (props) {
    const isSunday = computed(() => {
      if (props.date) {
        return dateLibs.isSunday(props.date)
      }
      return false
    })

    const getAmountRegularization = (item: PieceworkItemsInput) => {
      const total = Number(item.daily) - props.salaryCap
      if (total >= 0) {
        return total
      }
      return 0
    }

    const totalRegularization = computed(() => {
      return props.items.reduce((acc, item) => acc + Number(item.regularization), 0)
    })

    const totalAmountToPay = computed(() => {
      return props.items.reduce((acc, item) => acc + Number(item.amount_to_pay), 0)
    })

    const getEmployee = (employee_id: number) => {
      return props.employees.find(e => e.id === employee_id)
    }

    const calculateTime = (item: PieceworkItemsInput) => {
      const total_hours = getTotalWorking(item)
      if (total_hours >= 9) {
        item.total_hours = total_hours - 1.5
      } else {
        item.total_hours = total_hours
      }
    }

    const totalHours = computed(() => {
      const total = getTotalHoursPiecework(props.items)
      return total >= 0 ? total : 1
    })

    const { reasons, getReasonsForPermission } = useReasonForPermission()
    getReasonsForPermission()
    const textPermission = (item: PieceworkItemsInput) => {
      let text = 'Posee permisos:<br/>'
      item.permission_controls.forEach(p => {
        const reason = reasons.value.find(r => Number(r.id) === Number(p.reason_id))
        text += `Desde: ${dateLibs.formatDate(p.date_start)} - Hasta: ${dateLibs.formatDate(p.date_end)}<br/>`
        text += `Motivo: (${reason?.abbreviated}) ${reason?.description}<br/>`
      })
      return text
    }

    const hasPermission = (item: PieceworkItemsInput): boolean => {
      return item.permission_controls.length > 0
    }

    const textCondition = (item: PieceworkItemsInput) => {
      if (item.permission_controls.length > 0) {
        return textPermission(item)
      }
      if (item.time_in && item.time_out) {
        item.condition = ATTEND
        return CONDITIONS.find(c => c.value === ATTEND)?.text ?? ''
      }

      if (isSunday.value) {
        return '<br/><b>DOMINGO</b>'
      }

      if (props.isHoliday) {
        return '<br/><b>FERIADO</b>'
      }

      item.condition = ABSENT
      return CONDITIONS.find(c => c.value === ABSENT)?.text ?? ''
    }

    const rateLunch: Ref<PropOptionSelect[]> = ref([])
    const getRateLunchActive = async () => {
      const rateLunchActivate = await RatesLunchService.getAllActivated()
      rateLunch.value = rateLunchActivate.map(rate => {
        return {
          value: rate?.id ?? '',
          text: rate.name
        }
      })
    }
    getRateLunchActive()

    const getNameRateLunch = (id: number) => {
      const rate = rateLunch.value.find(ra => Number(ra.value) === Number(id))
      if (rate) {
        return rate.text
      }
      return ''
    }

    return {
      getAmountRegularization,
      totalRegularization,
      totalAmountToPay,
      getEmployee,
      calculateTime,
      totalHours,
      AMOUNT_LUNCH_TYPES,
      textCondition,
      getNameRateLunch,
      hasPermission
    }
  }
})
